import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=69c61fed&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=69c61fed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c61fed",
  null
  
)

export default component.exports